import { View } from '@/domain/mitarbeiter/features/rotationsplan/entities/views';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { FilterCombobox } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/FilterCombobox';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function BerufeFilter({ view }: { view: View }) {
  const { t } = useTranslation();
  const { store } = useRotationsplanFeatureContext();
  const {
    data: { berufe },
    ui: {
      kalender: {
        filter: { berufe: kalenderFilter },
      },
      uebersicht: {
        filter: { berufe: uebersichtFilter },
      },
    },
  } = store;
  const [selectedBerufe, setSelectedBerufe] = useState<string[]>(
    view === 'planung' ? kalenderFilter : uebersichtFilter,
  );

  const options = [...berufe]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((beruf) => ({ value: beruf.name, label: beruf.name }));

  function applySelection(newBerufe: string[]) {
    setSelectedBerufe(newBerufe);
    if (view === 'planung') {
      store.setKalenderBerufeFilter(newBerufe);
    } else {
      store.setUebersichtBerufeFilter(newBerufe);
    }
  }

  return (
    <FilterCombobox
      label={t('domain.mitarbeiter.rotationsplan.filter.berufe')}
      options={options}
      value={selectedBerufe}
      onValueChange={applySelection}
      onClear={() => applySelection([])}
    />
  );
}
